import { CommonModule } from '@angular/common';
import { Component, Input, OnInit } from '@angular/core';
import { RouterModule } from '@angular/router';
import { Store } from '@ngrx/store';
import { TranslateModule } from '@ngx-translate/core';
import { filter, take } from 'rxjs';
import { AppUiService } from 'src/app/app-ui.service';
import { CustomLabelsService } from 'src/app/core/custom-labels.service';
import { LocaleService } from 'src/app/core/locale/locale.service';
import { selectCatalog } from 'src/app/root-store/catalog-store/selectors';
import { CatalogSettings, CatalogState } from 'src/app/root-store/catalog-store/state';
import { RootState } from 'src/app/root-store/root-state.model';
import { ToHrefPipe } from '../to-href.pipe';

@Component({
  selector: 'app-footer',
  standalone: true,
  imports: [CommonModule, RouterModule, TranslateModule, ToHrefPipe],
  templateUrl: './footer.component.html',
  styleUrl: './footer.component.scss'
})
export class FooterComponent implements OnInit {
  showFooterBubble = this.appUiService.showFooterBubbleSignal
  settings?: CatalogSettings
  catalog?: CatalogState
  currentLang = this.localeService.currentLang

  @Input() showConditions = true

  constructor(
    private appUiService: AppUiService,
    private store: Store<RootState>,
    public customLabels: CustomLabelsService,
    private localeService: LocaleService,
  ) { }

  ngOnInit() {
    this.store.select(selectCatalog)
      .pipe(filter(c => !!c.id), take(1))
      .subscribe(catalog => {
        this.catalog = catalog
        this.settings = catalog.settings
      })
  }

  toggleFooterBubble() {
    this.appUiService.toggleFooterBubble()
  }
}
